import React, { useState } from 'react'
import "../../landingpage.css";
import ModularHeader from './ModularHeader';
import ModularFooter from './ModularFooter';
import LandingPageTwoBanner from './LandingPageTwoBanner';
import KitchenConsultation from './KitchenConsultation';
import KitchenStyles from './KitchenStyles';
import HomeCounter from '../Home/HomeCounter';
import KitchenPriceCalculator from './KitchenPriceCalculator';
import HowWeWork from './HowWeWork';
import HomeTestimonial from '../Home/HomeTestimonial';
import OurWorkGallery from './OurWorkGallery';
import KitchenExperience from './KitchenExperience';
import HomeConnect from '../Home/HomeConnect';
import Addpopup from '../../component/Addpopup';

export default function LandingModular() {
   const bannerData = {
      heading: "Modular Kitchens Built To Transform Your Home",
      description:
     "Experience smart functionality, premium finishes, and modern craftsmanship with Saysha’s customized modular kitchen solutions.",
      bannerImage: "/image/landtwobanner.webp"
   };

   const consultationData = {
      features: [
         {
            icon: "/image/kitchenconsultation-icon-1.webp",
            title: "Customized Modular <br/>Kitchens"
         },
         {
            icon: "/image/kitchenconsultation-icon-2.webp",
            title: "Expert Design & <br/>Manufacturing"
         },
         {
            icon: "/image/kitchenconsultation-icon-3.webp",
            title: "Premium Quality <br/>Finishes"
         },
         {
            icon: "/image/kitchenconsultation-icon-4.webp",
            title: "Smart Space <br/>Planning"
         },
         {
            icon: "/image/kitchenconsultation-icon-5.webp",
            title: "45-Day <br/>Installation*"
         },
         {
            icon: "/image/kitchenconsultation-icon-6.webp",
            title: "End-To-End <br/>Support"
         }
      ],

      formTitle: "Let's Start Building Your Dream Kitchen",

      formDescription: "Fill in your details below & our expert will call you back.",
   };

   const kitchenStylesData = {
      heading: "A Kitchen for Every Style & Home",

      description:
         "Explore modular kitchen layouts thoughtfully designed to maximize comfort, storage, and efficiency while complementing your interior style.",

      styles: [
         {
            image: "/image/kitchenstyles-card-1.webp",
            title: "Island Kitchen",
            description:
               "Create a luxurious cooking space with island kitchens designed for open layouts, extra workspace, and modern everyday living. "
         },
         {
            image: "/image/kitchenstyles-card-2.webp",
            title: "Straight Kitchen",
            description:
               "Simple and highly efficient, straight kitchens are perfect for compact homes, clean layouts, and modern functional living spaces."
         },
         {
            image: "/image/kitchenstyles-card-3.webp",
            title: "Parallel Kitchen",
            description:
               "Designed for smooth workflow, parallel kitchens offer organized work zones, optimized storage, and efficient everyday cooking experiences."
         },
         {
            image: "/image/kitchenstyles-card-4.webp",
            title: "U Shape Kitchen",
            description:
               "Maximize comfort and functionality with U-shaped kitchens offering smart storage, seamless accessibility, and efficient movement daily."
         },
         {
            image: "/image/kitchenstyles-card-5.webp",
            title: "L Shape Kitchen",
            description:
               "Versatile and space-efficient, L-shaped kitchens create practical layouts, open movement, and stylish functionality for modern homes today."
         },
         {
            image: "/image/kitchenstyles-card-6.webp",
            title: "G Shape Kitchen",
            description:
               "Experience premium functionality with G-shaped kitchens offering extended counters, enhanced storage, and efficient modern convenience. "
         }
      ]
   };

   const pricingData = {
      heading: "Kitchen Price Calculator",

      description:
         "Select Your Kitchen Layout, Add Measurements & Get An Estimated Budget",

      plans: [
         {
            tag: "Basic",
            title: "Essentials",

            features: [
               {
                  title: "Colours & Finishes:",
                  text: "Limited Colour Options"
               },
               {
                  title: "Convenience Level:",
                  text: "Essential shutters and drawer combinations"
               },
               {
                  title: "Hardware Category:",
                  text: "Blum Antarobox"
               },
               {
                  title: "Accessories & Lighting:",
                  text: "Basic Organisers"
               }
            ]
         },

         {
            tag: "Advanced",
            title: "Premium",

            features: [
               {
                  title: "Colours & Finishes:",
                  text: "Expanded colour options with glass shutters"
               },
               {
                  title: "Convenience Level:",
                  text: "More drawers, lift-ups, and utility enhancements"
               },
               {
                  title: "Hardware Category:",
                  text: "Blum Antarobox"
               },
               {
                  title: "Accessories & Lighting:",
                  text: "Basic Organisers & Under Cabinet lighting"
               }
            ]
         },

         {
            tag: "Pro",
            title: "Signature",

            features: [
               {
                  title: "Colours & Finishes:",
                  text: "Maximum colour options, Patterned & Tinted Glass shutters"
               },
               {
                  title: "Convenience Level:",
                  text: "Advanced lift-up systems and maximum drawer accessibility"
               },
               {
                  title: "Hardware Category:",
                  text: "Blum Legrabox & Tip-On Systems"
               },
               {
                  title: "Accessories & Lighting:",
                  text: "Premium organizers with under-cabinet and inner-cabinet lighting"
               }
            ]
         }
      ]
   };

   const workProcessData = {
      heading: "How We Work",

      description:
         "Complete Modular Kitchen Solutions - From Concept To Installation",

      process: [
         {
            number: "01",
            title: "Initial Consultation",
            description:
               "Start with a personalized consultation where our design experts understand your requirements, lifestyle preferences, kitchen functionality needs, and design expectations.",
            image: "/image/wework-img-1.webp"
         },

         {
            number: "02",
            title: "Space Analysis",
            description:
               "Our specialists conduct a detailed site analysis, taking precise measurements and understanding your kitchen layout to create an optimized modular solution.",
            image: "/image/wework-img-2.webp"
         },

         {
            number: "03",
            title: "Design & Budgeting",
            description:
               "We create customized kitchen designs along with transparent budget planning to ensure the perfect balance between aesthetics, utility, and investment.",
            image: "/image/wework-img-3.webp"
         },

         {
            number: "04",
            title: "Manufacturing & Installation",
            description:
               "With in-house manufacturing and professional installation teams, we ensure timely project execution, precision finishing, and quality assurance at every stage.",
            image: "/image/wework-img-4.webp"
         }
      ]
   };

  const galleryData = [
    {
      image: "/image/gallery-image-1.webp"
    },
    {
      image: "/image/gallery-image-2.webp"
    },
    {
      image: "/image/gallery-image-3.webp"
    },

    {
      image: "/image/gallery-image-4.webp"
    },
    {
      image: "/image/gallery-image-5.webp"
    },
    {
      image: "/image/gallery-image-6.webp"
    },
    {
      image: "/image/gallery-image-7.webp"
    },
    {
      image: "/image/gallery-image-8.webp"
    },
    
  ]

  const [show, setShow] = useState(false);

   const handleShow = ()=>{
        setShow(true)
    }
  
   return (
      <div className='change-background'>
         <Addpopup addPopShow={show} setAddPopShow={setShow} headingText={"Book your free kitchen design consultation"} paraText={"Talk to our expert designers and get a personalised layout plan - at no cost."} btnText={"Book A Free Consultation"}/>
         <ModularHeader />
         <LandingPageTwoBanner data={bannerData} handleShow={handleShow}/>
         <KitchenConsultation data={consultationData} />
         <KitchenStyles data={kitchenStylesData} handleShow={handleShow}/>
         <HomeCounter extraClass="addpage-counter" />
         <KitchenPriceCalculator data={pricingData} />
         <HowWeWork data={workProcessData} handleShow={handleShow}/>
         <HomeTestimonial extraClass="addpage-testimonial" />
         <OurWorkGallery galleryData={galleryData} handleShow={handleShow}/>
         <KitchenExperience handleShow={handleShow}/>
         <HomeConnect extraClass="addpage-connect" />
         <ModularFooter />
      </div>
   )
}
